import "regenerator-runtime/runtime";
import FactPagePopulator from "./FactPagePopulator";
import RecipeCardGenerator from "./RecipeCardGenerator";
window.onload = () => {
    RecipeCardGenerator.popupateAllRecipeCards();
    FactPagePopulator.populateFactPage();
};
//# sourceMappingURL=scripts.js.map